/** Query keys for the user activity feed. */
export const userActivityKeys = {
  all: () => ['user-activity'] as const,
  /** Per-group activity feed (`GET /api/v1/group/{groupId}/activity`). */
  group: (groupId: string) => ['user-activity', 'group', groupId] as const,
} as const;
